import DashboardNavbar from './DashboardNavbar';

const navbarComponents = { DashboardNavbar };

export { DashboardNavbar };
export default navbarComponents;
